module.exports = __webpack_public_path__ + "static/h3-eff3d10c06fc479dba26b8f974614720.jpg";